import React from 'react';

// Logo ChatHub — concept A validé par Marlon : bulle de chat bleue + 3 points (conversation).
export default function Logo({ size = 'md', withText = true, className = '' }) {
  const sizes = {
    sm: { box: 'w-7 h-7', text: 'text-base' },
    md: { box: 'w-9 h-9', text: 'text-lg' },
    lg: { box: 'w-12 h-12', text: 'text-2xl' },
    xl: { box: 'w-16 h-16', text: 'text-3xl' },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div className={`${s.box} shrink-0`}>
        <svg viewBox="0 0 64 64" className="w-full h-full" style={{ filter: 'drop-shadow(0 6px 14px rgba(63,125,255,.4))' }}>
          <defs>
            <linearGradient id="chLogoG" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stopColor="#3f7dff" />
              <stop offset="1" stopColor="#73a6ff" />
            </linearGradient>
          </defs>
          <path d="M14 9 h36 a9 9 0 0 1 9 9 v20 a9 9 0 0 1 -9 9 h-20 l-12 9 v-9 h-4 a9 9 0 0 1 -9 -9 v-20 a9 9 0 0 1 9 -9 z" fill="url(#chLogoG)" />
          <circle cx="23" cy="28" r="3.4" fill="#fff" />
          <circle cx="33" cy="28" r="3.4" fill="#fff" />
          <circle cx="43" cy="28" r="3.4" fill="#fff" />
        </svg>
      </div>
      {withText && (
        <span className={`font-display font-bold ${s.text} tracking-tight text-white`}>
          Chat<span className="text-indigo-400">Hub</span>
        </span>
      )}
    </div>
  );
}
